import { StringHelpers } from "../../helpers/string-helpers";
import { IChartContainer } from "../../models/base/chart-container.interface";
import { IChartDataService } from "../../models/base/chart-data-service.interface";
import { IComponent } from "../component.interface";

export class SymbolLookupComponent implements IComponent {
    public id = '';

    // public element: HTMLElement;
    // public inputSymbol: HTMLElement | null;
    public symbol = '';

    private chartService: IChartDataService;
    private base: IChartContainer;
    private readonly symbolSuggestionUrl = 'https://www.trade-ideas.com/ajax/symbol.php';

    constructor(base: IChartContainer) {
        this.chartService = base.chartService;
        this.base = base;

        // this.element = symbolContainerElement;

        // this.inputSymbol = symbolContainerElement.findFirst('#symbol-field');

        // this.onSymbolKeyUp();
        // this.onSymbolKeyPress();
        // this.onChangeSymbolClick();
        // this.onCloseClick();
        // this.onEscPress();
        this.onBodyKeyup();
    }

    public setSymbol(symbol: string) {
        // console.log(symbol)
        // this.symbol = symbol;
        // this.inputSymbol?.setValue(symbol);
    }
    
    // private isShow(): boolean {
    //     return this.element.containClass('active');
    // }

    // private show() {
    //     this.element.addClass('active');
    // }

    // private hide() {
    //     this.element.removeClass('active');
    // }

    // private onCloseClick() {
    //     this.element.querySelectorAll<HTMLElement>('.close').forEach((el: HTMLElement) => {
    //         el.addEventListener('click', () => {
    //             this.hide();
    //         });
    //     });
    // }

    // private onChangeSymbolClick() {
    //     this.element.querySelectorAll<HTMLElement>('.submit').forEach((el: HTMLElement) => {
    //         el.addEventListener('click', () => {
    //             this.changeSymbol();
    //         });
    //     });
    // }

    // private changeSymbol() {
    //     this.hide();

    //     if (!this.base.tiChartSeries || !this.inputSymbol) {
    //         return;
    //     }

    //     if (this.inputSymbol.value.length > 4 && this.inputSymbol.value.length < 1) {
    //         return;
    //     }

    //     if (this.inputSymbol.value == this.symbol) {
    //         return;
    //     }

    //     this.base.tiChartSeries.ready = false;
        
    //     this.base.setComponentStateWhenRequestingNewSymbol();
    //     this.symbol = this.inputSymbol.value;
    //     this.chartService.requestNewSymbol(this.symbol);
    // }

    // private onSymbolKeyUp() {
    //     this.inputSymbol?.addEventListener('keyup', (ev: any) => {
    //         if (!this.inputSymbol) {
    //             return;
    //         }

    //         if (ev && ev.keyCode === 13) {
    //             this.inputSymbol.blur();
    //             this.changeSymbol();
    //             return;
    //         }

    //         this.inputSymbol.value = this.inputSymbol.value?.toUpperCase() ?? '';
    //         this.base.hideTooltip();
    //     });
    // }

    // private onSymbolKeyPress() {
    //     this.inputSymbol?.addEventListener('keypress', (ev: any) => {
    //         var charCode = (ev.which) ? ev.which : ev.keyCode;
    //         if (charCode >= 48 && charCode <= 57) {
    //             ev.preventDefault();
    //         }
    //     });
    // }

    // private onEscPress() {
    //     this.base.domEvents.onEscPress(() => {
    //         if (this.isShow()) {
    //             this.hide();
    //         }
    //     });
    // }

    private onBodyKeyup() {
        document.body.addEventListener('keydown', (event: any) => {
            if (!this.base.tiChartSeries || this.base.tiChartSeries.isPopupVisible()) {
                return;
            }
            
            console.log('keydown ', event.key);
            if (StringHelpers.isAlphabetic(event.key)) {
                this.base.chartService.requestOpenSymbolLookup(event.key.toUpperCase());
            }

            // const symbolField = this.element.findFirst('#symbol-field');
            // if (symbolField) {
            //     if (this.isShow() || !StringHelpers.isAlphabetic(event.key)) {
            //         return;
            //     }

            //     this.inputSymbol?.setValue(event.key.toUpperCase());
                
            //     this.show();
            //     // this.requestSuggestionList();
            //     symbolField.focus();
            // }
        });
    }

    // private requestSuggestionList() {
    //     // const url = this.symbolSuggestionUrl + '?q=' + this.inputSymbol?.value;
    //     // this.base.requestService.get(url, (response: any) => {
    //     //     console.log(response);
    //     // }, (error: any) => {
    //     //     console.log(error);
    //     // })
    // }
}
